import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { Box, Typography, Grid, Button } from "@mui/material";
import { setPageTitle, addNewMessage } from "../slice";
import { PROFILES_API } from "../api";
import { useCurrentState } from "../hooks";
import ConfirmModal from "../components/ConfirmModal";

function Profile() {
  const dispatch = useDispatch();
  const [openConfirmEditModal, setOpenConfirmEditModal] = useState(false);
  const [openConfirmDeactiveModal, setOpenConfirmDeactiveModal] = useState(false);
  const updateUserStatus = useCurrentState();

  const { mutate: requestProfileEdit } = useMutation(() => PROFILES_API.RequestProfileEdit(), {
    onSuccess: ({ data }) => {
      if (data.success) {
        updateUserStatus();
        dispatch(
          addNewMessage({
            id: "success-on-request-profile-edit",
            text: data.message,
            type: "success",
          })
        );
      } else {
        dispatch(
          addNewMessage({
            id: "error-on-request-profile-edit",
            text: data.message,
            type: "error",
          })
        );
      }
    },
    onError: ({ response }) => {
      dispatch(
        addNewMessage({
          id: "error-on-request-profile-edit",
          text: response?.data.message,
          type: "error",
        })
      );
    },
    onSettled: () => setOpenConfirmEditModal(false),
  });
  const { mutate: requestProfileDeactive } = useMutation(
    () => PROFILES_API.RequestProfileDeactive(),
    {
      onSuccess: ({ data }) => {
        if (data.success) {
          updateUserStatus();
          dispatch(
            addNewMessage({
              id: "success-on-request-profile-Deactive",
              text: data.message,
              type: "success",
            })
          );
        } else {
          dispatch(
            addNewMessage({
              id: "error-on-request-profile-Deactive",
              text: data.message,
              type: "error",
            })
          );
        }
      },
      onError: ({ response }) => {
        dispatch(
          addNewMessage({
            id: "error-on-request-profile-Deactive",
            text: response?.data.message,
            type: "error",
          })
        );
      },
      onSettled: () => setOpenConfirmDeactiveModal(false),
    }
  );

  useEffect(() => {
    dispatch(setPageTitle("پروفایل"));
  }, [dispatch]);

  return (
    <Box display="flex" flexDirection="column" alignItems="end" width="100%" minHeight="100vh">
      <ConfirmModal
        message="آیا از ارسال درخواست ویرایش پروفایل به مرکز اطمینان دارید؟"
        open={openConfirmEditModal}
        onClose={() => setOpenConfirmEditModal(false)}
        onSubmit={requestProfileEdit}
      />
      <ConfirmModal
        message="آیا از ارسال درخواست غیرفعالسازی پروفایل به مرکز اطمینان دارید؟"
        open={openConfirmDeactiveModal}
        onClose={() => setOpenConfirmDeactiveModal(false)}
        onSubmit={requestProfileDeactive}
      />
      <Grid
        container
        display="flex"
        flexDirection={{ xs: "column-reverse", sm: "row" }}
        justifyContent="space-between"
        bgcolor="#FAFAFA"
        p={3}
        my={3}
        borderRadius={3}
      >
        <Grid item xs={12} sm={3} display="flex" justifyContent="center">
          <Button
            variant="m1"
            onClick={() => setOpenConfirmEditModal(true)}
            sx={{ display: "inline-block", width: "100%", maxWidth: 200, textAlign: "center" }}
          >
            درخواست ویرایش پروفایل
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h1" textAlign="right">
            تغییر اطلاعات شخصی
          </Typography>
          <Typography
            variant="h2"
            textAlign={{ xs: "justify", sm: "right" }}
            mt={{ xs: 1, sm: 3 }}
            mb={{ xs: 2, sm: 0 }}
          >
            برای ویرایش پروفایل کاربری‌تان می توانید برای هدا درخواست بگذارید تا کارشناسان ما دسترسی
            را برای شما باز کنند یا در صورت نیاز با شما تماس برقرار کنند
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        bgcolor="#FAFAFA"
        p={3}
        borderRadius={3}
        display="flex"
        justifyContent="space-between"
        flexDirection={{ xs: "column-reverse", sm: "row" }}
      >
        <Grid item xs={12} sm={3} display="flex" justifyContent="center">
          <Button
            variant="m1"
            onClick={() => setOpenConfirmDeactiveModal(true)}
            sx={{ display: "inline-block", width: "100%", maxWidth: 200, textAlign: "center" }}
          >
            غیر فعالسازی پروفایل
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h1" textAlign="right">
            غیر فعال کردن پروفایل کاربری
          </Typography>
          <Typography
            variant="h2"
            textAlign={{ xs: "justify", sm: "right" }}
            mt={{ xs: 1, sm: 3 }}
            mb={{ xs: 2, sm: 0 }}
          >
            اگر دیگر نمی خواهید پروفایل شما در هدا نمایش داده شود و می خواهید حساب کاربری شما غیر
            فعال شود، می توانید از این بخش درخواست خود را به مرکز ارسال نمایید
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Profile;
